import React from 'react';

function Send(props) {
  return (
    <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        clipRule="evenodd"
        d="M3.21205 2.95346C2.40883 3.49132 2.14111 4.56539 2.62106 5.42432L6.648 11.9933L2.63358 18.5548C2.32004 19.1146 2.30336 19.767 2.57613 20.3201C3.03502 21.2491 4.15902 21.631 5.08762 21.1723L20.9392 13.109C21.1739 12.9909 21.3664 12.7983 21.4866 12.5613C21.7992 11.9461 21.5546 11.1942 20.9396 10.8809L5.08679 2.82783C4.53311 2.55537 3.88173 2.57203 3.3433 2.8731L3.21205 2.95346ZM19.1412 11.3694L4.52776 3.94584C4.34969 3.85826 4.13275 3.86381 3.95288 3.96439C3.65149 4.13257 3.54382 4.51313 3.69949 4.79277L7.73159 11.3694H19.1412ZM7.73188 12.6194L3.71217 19.1861C3.61192 19.3654 3.60636 19.583 3.69703 19.7668C3.85025 20.077 4.22486 20.2043 4.52746 20.0549L19.145 12.6194H7.73188Z"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default Send;
